import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TradingChart.scss';
import { app } from '../../../../data/AppController';
import { TradingToken } from '../../../../replicant/features/offchainTrading/offchainTrading.getters';
import {
  LightweightChartComponent,
  GraphPoint,
} from '../../TradingPage/LightweightChartComponent/LightweightChartComponent';
import {
  offchainTokenDisplayMultiplier,
  SliceConfig,
  tokenPriceSliceConfigs,
} from '../../../../replicant/features/offchainTrading/offchainTrading.ruleset';
import { DAY_IN_MS } from '../../../../replicant/utils/time';

interface TimeInterval {
  sliceConfig: SliceConfig | null;
  text: string;
  textP?: Record<string, any>;
}

const intervals: TimeInterval[] = [
  {
    sliceConfig: tokenPriceSliceConfigs.hour24,
    text: 'trading_chart_1_day',
  },
  {
    sliceConfig: tokenPriceSliceConfigs.day7,
    text: 'trading_chart_x_days',
    textP: { days: 7 },
  },
  {
    sliceConfig: tokenPriceSliceConfigs.day30,
    text: 'trading_chart_x_days',
    textP: { days: 30 },
  },
  {
    sliceConfig: null,
    text: 'trading_chart_all_time',
  },
];

interface Props {
  data: TradingToken;
}

export const TradingChart = ({ data }: Props) => {
  // If you are translating within the component use `i18n.t()` not the imported `t()`
  const { t } = useTranslation();

  const [priceData, setPriceData] = useState<GraphPoint[]>([]);

  const [selectedInterval, setSelectedInterval] = useState(intervals[3]);

  // @todo: reenable logic?
  // @note: seems better with allTime selected by default
  // const [currentId, setCurrentId] = useState(data.id);

  // useEffect(() => {
  //   setPriceData(
  //     app.trading.getOffchainTokenPricePoints(
  //       data,
  //       selectedInterval.sliceConfig,
  //     ),
  //   );

  //   let intervalIndex = 2;

  //   const timeSinceCreation = app.now() - data.createdAt;

  //   if (timeSinceCreation < DAY_IN_MS) {
  //     intervalIndex = 0;
  //   } else if (timeSinceCreation <= DAY_IN_MS * 7) {
  //     intervalIndex = 1;
  //   }

  //   // Only update the selected interval when a new id is selected, not on supply change
  //   if (data.id !== currentId) {
  //     setCurrentId(data.id);
  //     setSelectedInterval(intervals[intervalIndex]);
  //   }
  // }, [data?.id, data?.supply, currentId]);

  useEffect(() => {
    setPriceData(
      app.trading.getOffchainTokenPricePoints(
        data,
        selectedInterval.sliceConfig,
      ),
    );
  }, [selectedInterval]);

  const colors = {
    backgroundColor: 'transparent',
    lineColor: 'rgba(0, 150, 0, 1)', // #2962FF',
    textColor: '#777', //'white',
    areaTopColor: 'rgba(0, 150, 0, 1)', // '#2962FF',
    areaBottomColor: 'rgba(0, 150, 0, 0.0)', // 'rgba(41, 98, 255, 0.28)',
  };

  return (
    <div className="trading-chart" style={{ overflowY: 'auto' }}>
      <LightweightChartComponent
        data={priceData}
        colors={colors}
        height={240}
        multiplier={1 / offchainTokenDisplayMultiplier}
      />
      <div className="time-interval-buttons">
        {intervals.map((interval, index) => (
          <button
            key={`${interval.text}_${index}`}
            className={`interval-button ${
              selectedInterval.sliceConfig === interval.sliceConfig
                ? 'active'
                : ''
            }`}
            onClick={() => setSelectedInterval(interval)}
          >
            {t(interval.text, interval.textP)}
          </button>
        ))}
      </div>
    </div>
  );
};
